export interface IWaitlistAllocationPoints {
    cpraPoints: number;
    waitPoints: number;
    agePoints: number;
    epletMmPoints: number;
    totalPoints: number;
}
